// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bbt-rrawer {\r\n  border-radius: 6px 6px 0px 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;
